import { FormArray, FormBuilder, Validators } from '@angular/forms';
var TabFormsComponent = /** @class */ (function () {
    function TabFormsComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.isDuplicatedForm = false;
    }
    TabFormsComponent.prototype.addForm = function () {
        var segmentTypeMaintenanceForm = this.formBuilder.group({
            form: this.formBuilder.control(null, [Validators.required]),
            requiredComplete: this.formBuilder.control(false),
            requiredReport: this.formBuilder.control(false),
            requiredStart: this.formBuilder.control(false),
            maintenanceType: this.formBuilder.control(null, [Validators.required]),
        });
        this.segmentMaintenanceFormsArray.setControl(this.segmentMaintenanceFormsArray.controls.length, segmentTypeMaintenanceForm);
        if (this.isViewMode) {
            this.segmentMaintenanceFormsArray.disable();
        }
    };
    TabFormsComponent.prototype.removeForm = function (index) {
        this.segmentMaintenanceFormsArray.removeAt(index);
    };
    return TabFormsComponent;
}());
export { TabFormsComponent };
